// rescontrolcambios.schema.ts



import * as yup from 'yup';

export const servidorSchema = yup.object({
  servidorId: yup.string().optional(),
  tipoServidor: yup.string().required('El tipo de servidor es obligatorio'),
  nombreServidor: yup.string().required('El nombre del servidor es obligatorio'),
  ubicacionServidor: yup.string().required('La ubicación es obligatoria'),
 subId: yup
    .number()
    .typeError('El sub id debe ser numérico')
    .required('El sub id es obligatorio')
    .integer('El Sub ID debe ser un número entero.')
    .positive('El Sub ID debe ser mayor que cero.'),
  servidorVirtual: yup.string().required('El servidor virtual es obligatorio'),
  ipServidor: yup
  .string()
  .required('La IP del servidor es obligatoria')
  .matches(
    /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/,
    'Debe ingresar una dirección IP válida. Ejemplo válido: "192.168.1.1"'
  ),
  ambiente: yup.string().required('El ambiente es obligatorio'),
  sistemaOperativo: yup.string().required('El sistema operativo es obligatorio'),
  tecnologiaServidor: yup.string().required('La tecnología es obligatoria'),
  categoria: yup.string().required('La categoría es obligatoria'),
  descripcionServidor: yup
  .string()
  .required('La descripción es obligatoria')
  .matches(
    /^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9.,\s]+$/,
    'Solo se permiten letras, números, espacios, puntos, comas y caracteres con tilde'
  ),
  estado: yup.boolean().required(),
  estadoCritico: yup.boolean().required(),
});
